<!--
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-03-09 09:11:13
-->
<template>
  <div class="main-container">
    <header-nav />
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>
<script>
import headerNav from './Header'
export default {
  components: {
    headerNav
  }
}
</script>
<style scoped lang='scss'>
body {
  background: #F0F2FA;
}
.main-container {
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  background: #F0F2FA;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  min-height: 100%;
}

main {
  width: 100%;
  max-width: 1110px;
  margin: 0 auto;
  background: #fff;
  font-size: 15px;
  font-weight: 400;
  color: #4E5A73;
  line-height: 30px;
  // min-height: calc(100vh - 13.89vw);
  position: relative;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue